import { render, staticRenderFns } from "./star.vue?vue&type=template&id=60ba2b82&"
import script from "./star.vue?vue&type=script&lang=js&"
export * from "./star.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60ba2b82')) {
      api.createRecord('60ba2b82', component.options)
    } else {
      api.reload('60ba2b82', component.options)
    }
    module.hot.accept("./star.vue?vue&type=template&id=60ba2b82&", function () {
      api.rerender('60ba2b82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/star.vue"
export default component.exports